import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";

declare var ko: any;

export class flightTrackerPagesEdit_template extends vnTemplate {

    public static TYPES = [
        {id: "airport", name: "Airport"},
        {id: "airline", name: "Airline"},
        {id: "aircraft", name: "Aircraft code"},
        {id: "aircraftType", name: "Aircraft type"}
    ];

    public static INDEX_OVERRIDES = [
        {id: "auto", name: "Auto (use traffic threshold)"},
        {id: "index", name: "Force index"},
        {id: "noindex", name: "Force noindex"}
    ];

    protected getTemplateHtml(): string {
        return /*html*/ `
            <div class="form-header">
                <h3 class="form-title">Flight Tracker Page</h3>
                <h3 class="form-title" data-bind="text: name"></h3>
                <button data-bind="event: { click: onClickCancelEdit }" class="close-button icon i-close-2" type="button"></button>
            </div>
            <div class="w-form-body">
                <div class="form-body">
                    <div class="form-group">
                        <label for="type" class="form-label">Type</label>
                        <select id="type" class="input-text" data-bind="options: types, optionsText: 'name', optionsValue: 'id', value: type"></select>
                    </div>
                    <div class="form-group">
                        <label for="name" class="form-label">Name</label>
                        <input id="name" data-bind="value: name" type="text" class="input-text" placeholder="e.g. Montreal-Trudeau International Airport">
                    </div>
                    <div class="form-group">
                        <label for="slug" class="form-label">Slug</label>
                        <input id="slug" data-bind="value: slug, event: { focusout: onFocusOutName }" type="text" class="input-text" placeholder="e.g. yul">
                        <p class="form-text">Public URL: <span data-bind="text: '/flight-tracker/' + (slug() || '{slug}') + '/'"></span></p>
                    </div>
                    <div class="form-group">
                        <label for="code" class="form-label">Code (IATA / ICAO / type code)</label>
                        <input id="code" data-bind="value: code" type="text" class="input-text" placeholder="e.g. YUL / CYUL / B738">
                    </div>
                    <div class="form-group">
                        <label for="city" class="form-label">City</label>
                        <input id="city" data-bind="value: city" type="text" class="input-text">
                    </div>
                    <div class="form-group">
                        <label for="country" class="form-label">Country</label>
                        <input id="country" data-bind="value: country" type="text" class="input-text">
                    </div>
                    <div class="form-group">
                        <label class="form-label">Map view (optional)</label>
                        <div class="row">
                            <input id="lat" data-bind="value: lat" type="number" step="any" class="input-text" placeholder="Latitude">
                            <input id="lon" data-bind="value: lon" type="number" step="any" class="input-text" placeholder="Longitude">
                            <input id="zoom" data-bind="value: zoom" type="number" step="1" class="input-text" placeholder="Zoom">
                        </div>
                    </div>
                    <div class="form-group">
                        <input type="checkbox" data-bind="checked: enrichFromAirNav" id="enrichFromAirNav">
                        <label class="icon i-check" for="enrichFromAirNav">Fill empty airport fields from AirNav on save (ICAO code required)</label>
                    </div>
                </div>

                <div class="form-body">
                    <strong class="form-sub-title">SEO overrides (optional, leave blank to auto-generate a unique tag)</strong>
                    <div class="form-group">
                        <label for="titleTag" class="form-label">&lt;title&gt; override</label>
                        <input id="titleTag" data-bind="value: titleTag" type="text" class="input-text">
                    </div>
                    <div class="form-group">
                        <label for="h1Tag" class="form-label">&lt;h1&gt; override</label>
                        <input id="h1Tag" data-bind="value: h1Tag" type="text" class="input-text">
                    </div>
                    <div class="form-group">
                        <label for="metaDescription" class="form-label">Meta description override</label>
                        <textarea id="metaDescription" data-bind="value: metaDescription" class="input-text"></textarea>
                    </div>
                </div>

                <div class="form-body">
                    <strong class="form-sub-title">Indexing</strong>
                    <div class="form-group">
                        <label for="indexOverride" class="form-label">Indexing mode</label>
                        <select id="indexOverride" class="input-text" data-bind="options: indexOverrides, optionsText: 'name', optionsValue: 'id', value: indexOverride"></select>
                    </div>
                    <div class="form-group" data-bind="visible: indexOverride() === 'auto'">
                        <label for="pageviewThreshold" class="form-label">Weekly pageview threshold (blank uses default of <span data-bind="text: defaultThreshold"></span>)</label>
                        <input id="pageviewThreshold" data-bind="value: pageviewThreshold" type="number" step="1" class="input-text">
                    </div>
                    <!-- ko if: editionMode -->
                    <div class="form-group">
                        <p class="form-text">Last synced weekly views: <strong data-bind="text: weeklyPageviews"></strong></p>
                        <p class="form-text">Currently indexed: <strong data-bind="text: indexed() ? 'Yes' : 'No'"></strong></p>
                        <p class="form-text">Last synced at: <strong data-bind="text: lastSyncedAt() || 'never'"></strong></p>
                    </div>
                    <!-- /ko -->
                </div>
            </div>

            <div class="form-footer">
                <button data-bind="event: { click: onClickCancelEdit }" class="btn" type="button">Cancel</button>
                <button data-bind="event: { click: onClickSave }" class="btn highlight" type="button">Save</button>
            </div>
            `;
    }

    protected getMainElementClasses(): Array<string> {
        return ["w-form", "static", "w-form-large"];
    }

    protected buildViewModel(): any {
        let self = this
        return {
            id: ko.observable(""),
            slug: ko.observable(""),
            type: ko.observable("airport"),
            code: ko.observable(""),
            name: ko.observable(""),
            city: ko.observable(""),
            country: ko.observable(""),
            lat: ko.observable(""),
            lon: ko.observable(""),
            zoom: ko.observable(""),
            titleTag: ko.observable(""),
            h1Tag: ko.observable(""),
            metaDescription: ko.observable(""),
            indexOverride: ko.observable("auto"),
            pageviewThreshold: ko.observable(""),
            enrichFromAirNav: ko.observable(false),
            weeklyPageviews: ko.observable(0),
            indexed: ko.observable(false),
            lastSyncedAt: ko.observable(""),
            defaultThreshold: ko.observable(100),
            contextApp: ko.observable(""),
            editionMode: ko.observable(false),
            types: flightTrackerPagesEdit_template.TYPES,
            indexOverrides: flightTrackerPagesEdit_template.INDEX_OVERRIDES,
            onClickCancelEdit: function (data, event) {
                self.onClickCancelEdit();
            },
            onClickSave: function (data, event) {
                self.onClickSave()
            },
            onFocusOutName: (data, event) => {
                self.onFocusOutName(event);
            }
        }
    }

    protected getTemplateName(): string {
        return "flightTrackerPagesEdit_template";
    }

    protected onFocusOutName(event) {
        let slug = this.getTemplateViewModel().slug();
        if ((slug == null || slug === "") && event.target.value) {
            this.getTemplateViewModel().slug(this.slugify(event.target.value));
        }
    }

    private slugify(value: string): string {
        return value.toLowerCase().trim()
            .replace(/[^\w -]+/g, '')
            .replace(/[ _]+/g, '-')
            .replace(/-{2,}/g, '-')
            .replace(/^-|-$/g, "");
    }

    public setData(page) {
        let vm = this.getTemplateViewModel();
        vm.id(page.id || "");
        vm.slug(page.slug || "");
        vm.type(page.type || "airport");
        vm.code(page.code || "");
        vm.name(page.name || "");
        vm.city(page.city || "");
        vm.country(page.country || "");
        vm.lat(page.view ? page.view.lat : "");
        vm.lon(page.view ? page.view.lon : "");
        vm.zoom(page.view ? page.view.zoom : "");
        vm.titleTag(page.titleTag || "");
        vm.h1Tag(page.h1Tag || "");
        vm.metaDescription(page.metaDescription || "");
        vm.indexOverride(page.indexOverride || "auto");
        vm.pageviewThreshold(page.pageviewThreshold != null ? page.pageviewThreshold : "");
        vm.weeklyPageviews(page.weeklyPageviews || 0);
        vm.indexed(!!page.indexed);
        vm.lastSyncedAt(page.lastSyncedAt || "");
    }

    public setDefaultThreshold(threshold) {
        this.getTemplateViewModel().defaultThreshold(threshold);
    }

    public isEditionMode(value) {
        this.getTemplateViewModel().editionMode(value)
    }

    public setContextApp(text) {
        this.getTemplateViewModel().contextApp(text)
    }

    protected onClickCancelEdit(): any {
        this.caller.onClickCancelEdit();
    }

    protected onClickSave(): any {
        this.caller.save()
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/flightTrackerPagesEdit_template.ts